import type { SVGProps } from "react";

export function IconPurpleFlag(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M8.00004 12H54.5L44.5 40H5L24 26.6667L8.00004 12Z"
        fill="#2E2E2E"
        stroke="#2E2E2E"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56 5.75C54.7574 5.75 53.75 6.75736 53.75 8C53.75 9.24264 54.7574 10.25 56 10.25C57.2427 10.25 58.25 9.24264 58.25 8C58.25 6.75736 57.2427 5.75 56 5.75ZM52.25 8C52.25 5.92893 53.929 4.25 56 4.25C58.0711 4.25 59.75 5.92893 59.75 8C59.75 10.0711 58.0711 11.75 56 11.75C55.8157 11.75 55.6346 11.7367 55.4574 11.711L46.5944 36.2547L46.5907 36.2649L46.5906 36.2648L38.135 58.6667H36.5317L36.6317 58.4018L45.1854 35.7403L54.0465 11.2016C52.9691 10.5428 52.25 9.35537 52.25 8Z"
        fill="#2A222A"
      />
    </svg>
  );
}
